@if (perms.support.write && org) {
  <acc-button data-screenshot-ignore size="sm" status="info"
              class="action" [class.hidden]="!showWidget" accClass="support-btn"
              (accClick)="openSupportTicket()" [loadingTimeout]="0">
    <acc-icon name="support"/>
  </acc-button>
}

<acc-modal #supportTicketTpl data-screenshot-ignore
           type="input" action="process" [config]="modalConfig" [options]="modalOptions"
           [title]="'support.ticket.create.title'|translate" titleIconName="support"
           (accConfirmed)="createTicket()"
           (accClosed)="closeSupportTicket()"
           (accCanceled)="closeSupportTicket()">
  @if (wrapper) {
    <acc-form [wrapper]="wrapper" [showFooter]="false">
      <acc-form-input name="subject" [wrapper]="wrapper"/>
      <acc-form-text-editor name="description" [wrapper]="wrapper" [config]="editorConfig"/>
      <acc-form-select name="priority" [wrapper]="wrapper"/>
      @if (isScreenshotSupported()) {
        <acc-form-switch name="screenshot" [wrapper]="wrapper"/>
        @if (screenshotUrl) {
          <div class="screenshot-preview mb-3">
            <img [src]="screenshotUrl" [alt]="'support.screenshot.create'|translate" class="img-fluid border mb-1"/>
            <acc-button size="sm" status="outline-danger" (accClick)="removeScreenshot()" [loadingTimeout]="0">
              <acc-icon name="delete"/>
              {{ 'delete'|translate }}
            </acc-button>
          </div>
        }
      }
      <acc-form-switch name="attachment" [wrapper]="wrapper"/>
      @if (showAttachments || screenshotUrl) {
        <div class="form-text mb-2">{{ 'support.attachment.hint'|translate }}</div>
      }
      @if (showAttachments) {
        <acc-form-file #attachment1 name="attachment1" [wrapper]="wrapper" [config]="fileConfig"/>
        <acc-form-file #attachment2 name="attachment2" [wrapper]="wrapper" [config]="fileConfig"/>
        <acc-form-file #attachment3 name="attachment3" [wrapper]="wrapper" [config]="fileConfig"/>
      }
    </acc-form>
  }
</acc-modal>

<acc-modal #supportUnavailableTpl type="show" action="cancel" [config]="unavailableConfig">
  <acc-support-unavailable/>
</acc-modal>
